
import React from 'react';
import { Link } from 'react-router-dom';

const PageFooter = () => {
  return (
    <footer className="mt-8 py-4 border-t border-gray-200">
      <div className="container mx-auto max-w-4xl">
        <div className="flex justify-center space-x-6 text-sm text-gray-500">
          <Link to="/terms" className="hover:text-gray-800 hover:underline">Terms & Conditions</Link>
          <Link to="/privacy" className="hover:text-gray-800 hover:underline">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default PageFooter;
